exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-4e0986d2] {\n  padding:4px 24px 0px 24px;\n  font-weight:bold;\n}\n.btn-report[data-v-4e0986d2] {\n  color: #343a40;\n  border-color: #343a40 !important;\n}\n.btn-report[data-v-4e0986d2]:hover {\n  color: #343a40;\n  border-color: #343a40 !important;\n  background-color: #fff !important;\n}\n.disabled[data-v-4e0986d2] {\n  cursor: not-allowed;\n  color: gray\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4e0986d2","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/ReportDropdownList.vue
// module id = U71S
// module chunks = 70